import type { DeviceProduct } from '@/hooks/prescription/usePrescriptionForm';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updateDevicePadItems: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (devicePadItems: DeviceProduct[]) => void
> = (set) => (devicePadItems) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionPad.devicePadItems = devicePadItems;
    },
    false,
    'prescriptionPad/updateDevicePadItems',
  );
